import { ContentPrice } from '../../model/ContentPrice';
import { MemoryCache } from '../../utils/MemoryCache';

export const content_price_cache = MemoryCache<ContentPrice>();
